import { useIntl } from "react-intl";
export default function AppInput({ name, label, placeholder, value, onChange, ...props }) {
  const intl = useIntl();
  return (
    <input className="form" placeholder={intl.formatMessage({ id: placeholder ?? "-" })} value={value} onChange={(e) => onChange(e.target?.value)} {...props} />
  );
}
